import React from "react";
import { Link } from "react-router-dom";
import { Home as HomeIcon, ArrowRight } from "lucide-react";
import Seo from "../components/Seo";
import { useLang } from "../i18n/LanguageContext";
import { navPaths } from "../mock/mock";

const T = {
  it: {
    title: "404 — Pagina non trovata | MichelChef®",
    eyebrow: "Errore 404",
    heading: "Questa pagina non esiste (più)",
    text: "La pagina che stai cercando non è disponibile o è stata rimossa. Torna alla home o esplora il sito.",
    home: "Torna alla home",
    contact: "Contattaci",
  },
  en: {
    title: "404 — Page not found | MichelChef®",
    eyebrow: "Error 404",
    heading: "This page doesn't exist (anymore)",
    text: "The page you're looking for is not available or has been removed. Go back home or explore the site.",
    home: "Back to home",
    contact: "Contact us",
  },
};

export default function NotFound() {
  const { lang } = useLang();
  const c = T[lang] || T.it;
  return (
    <main data-testid="not-found-page" className="min-h-[70vh] grid place-items-center bg-[#F3EFE7] px-5 py-24">
      <Seo title={c.title} description={c.text} path="/404" noindex />
      <div className="text-center max-w-xl">
        <span className="inline-block text-[#D8382E] font-semibold text-sm uppercase tracking-wider" data-testid="not-found-eyebrow">
          {c.eyebrow}
        </span>
        <h1 className="font-display font-extrabold text-[#14110F] text-7xl sm:text-8xl mt-3 leading-none">404</h1>
        <h2 className="font-display font-bold text-[#14110F] text-xl md:text-2xl mt-4">{c.heading}</h2>
        <p className="mt-4 text-[#3B342E]/75">{c.text}</p>
        <div className="mt-8 flex flex-wrap gap-4 justify-center">
          <Link
            to={navPaths.home}
            data-testid="not-found-home-btn"
            className="btn-press inline-flex items-center gap-2 rounded-full bg-[#17784A] text-white px-7 py-3.5 font-semibold hover:bg-[#125e3a]"
          >
            <HomeIcon size={18} /> {c.home}
          </Link>
          <Link
            to={navPaths.contact}
            data-testid="not-found-contact-btn"
            className="btn-press inline-flex items-center gap-2 rounded-full border border-black/15 text-[#14110F] px-7 py-3.5 font-semibold hover:bg-black/5"
          >
            {c.contact} <ArrowRight size={18} />
          </Link>
        </div>
      </div>
    </main>
  );
}
